import UtilService from "./DataService";

const MODEL = 'util_language';

class UtilLanguageService extends UtilService {
    constructor() {
        super(MODEL);
    }


    prepareFormData = (request = {}) => {
        var bodyFormData = new FormData();
        if (request.code !== null && request.code !== undefined) bodyFormData.append('code', request.code);
        if (request.name !== null && request.name !== undefined) bodyFormData.append('name', request.name);
        if (request.description !== null && request.description !== undefined) bodyFormData.append('description', request.description);
        return bodyFormData;
    };

}

export const utilLanguageService = new UtilLanguageService();
